import { createAxiosClient } from "@ntg/component-library/utilities";
import { IManufacturingItemInit } from "../../declarations/ManufacturingItemInit";
import { useQuery } from "@tanstack/react-query";

const getManufacturingItemInit = async (
    orderItemID: number,
): Promise<IManufacturingItemInit> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IManufacturingItemInit>(
        `/ManufacturingSearch/GetManufacturingItemInit/${orderItemID}`,
    );
    return response.data;
};

export const useGetManufacturingItemInit = (orderItemID: number) =>
    useQuery<IManufacturingItemInit>({
        enabled: orderItemID > 0,
        queryFn: () => getManufacturingItemInit(orderItemID),
        queryKey: ["GetManufacturingItemInit", orderItemID],
        refetchOnWindowFocus: false,
        retry: false,
    });
